import React from "react";

import styles from './Header.module.css';

import {useScreenDetector} from "../../../hooks/useScreenDetector.ts";
import {HeaderDesktop} from "./components/Desktop/HeaderDesktop.tsx";
import {HeaderMobile} from "./components/Mobile/HeaderMobile.tsx";
import {cn} from "../../../utils/cn.ts";

export const Header: React.FC = () => {
    const {isMobile, isDesktop} = useScreenDetector();

    return (
        <header className={cn(styles.header, 'header')}>
            {isDesktop && (<HeaderDesktop />)}

            {isMobile && (<HeaderMobile />)}
        </header>
    )
}